import React from "react";
import { Form, Input, Button } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const PasswordLoginForm = ({ onLogin, loading }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const onFinish = async (values) => {
    await onLogin(values.username, values.password);
  };

  return (
    <Form
      form={form}
      name="login"
      onFinish={onFinish}
      autoComplete="off"
      size="large"
      layout="vertical"
    >
      <Form.Item
        name="username"
        label={t("login.username")}
        rules={[
          { required: true, message: t("login.usernameRequired") },
          { type: "email", message: t("login.emailFormatError") },
        ]}
      >
        <Input
          prefix={<UserOutlined />}
          placeholder={t("login.username")}
        />
      </Form.Item>

      <Form.Item
        name="password"
        label={t("login.password")}
        rules={[
          { required: true, message: t("login.passwordRequired") },
          { min: 8, max: 20, message: t("login.passwordLengthError") },
        ]}
      >
        <Input.Password
          prefix={<LockOutlined />}
          placeholder={t("login.password")}
        />
      </Form.Item>

      <Form.Item shouldUpdate>
        {() => {
          const username = form.getFieldValue("username");
          const password = form.getFieldValue("password");
          const passwordValid =
            !!password && password.length >= 8 && password.length <= 20;
          const disabled = !username || !passwordValid;
          return (
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              disabled={disabled}
              style={{ width: "100%" }}
            >
              {t("login.loginButton")}
            </Button>
          );
        }}
      </Form.Item>
    </Form>
  );
};

export default PasswordLoginForm;
